export default {
  "pl": {
    "building": {
      "attributes": {
        "description": "Opis",
        "elevators": "Liczba wind",
        "end_date": "Data ukończenia",
        "floors": "Liczba pięter",
        "internal_note": "Notatka do użytku wewnętrznego",
        "name": "Nazwa",
        "start_date": "Data rozpoczęcia",
        "surface_shared": "Powierzchnia przestrzeni wspólnej"
      },
      "labels": {
        "building": "Brak budynków | 1 budynek | Liczba budynków: {count}"
      },
      "toasts": {
        "create": "Utworzono budynek",
        "delete": "Usunięto budynek",
        "update": "Zaktualizowano budynek"
      },
      "validation": {
        "needName": "Należy podać tytuł",
        "needNumber": "Należy podać liczbę (np. 85)"
      }
    }
  }
}
